import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Typography,
  Divider,
} from "@mui/material";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";

const EventTypeDropdown = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedEvents, setSelectedEvents] = useState<string[]>([
    "30 Minute Meeting",
  ]);

  const open = Boolean(anchorEl);

  const events = [
    {
      id: 1,
      name: "30 Minute Meeting",
      duration: "30 mins • Google Meet",
    },
  ];

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleSelect = (name: string) => {
    setSelectedEvents((prev) =>
      prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name]
    );
  };

  const handleSelectAll = () => {
    setSelectedEvents(events.map((e) => e.name));
  };

  const handleClear = () => {
    setSelectedEvents([]);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          color: "#1976d2",
          fontWeight: 600,
          cursor: "pointer",
        }}
        onClick={handleClick}
      >
        <Typography variant="body2" sx={{background: "linear-gradient(180deg, #805EDE 0%, #453378 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent"}}>
          {selectedEvents.length} event type
        </Typography>
        <KeyboardArrowDown
          sx={{
            fontSize: 18,
            ml: 0.3,
            transition: "transform 0.2s",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </Box>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <Box sx={{ p: 1, width: 300 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Typography
              sx={{ cursor: "pointer", color: "primary.main" }}
              onClick={handleSelectAll}
            >
              select all
            </Typography>
            <Typography
              sx={{ cursor: "pointer", color: "primary.main" }}
              onClick={handleClear}
            >
              clear
            </Typography>
          </Box>

          <Divider sx={{ my: 1 }} />

          {events.map((event) => (
            <MenuItem key={event.id} onClick={() => toggleSelect(event.name)}>
              <Checkbox checked={selectedEvents.includes(event.name)} />
              <Box>
                <Typography sx={{ fontWeight: 500, }}>{event.name}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {event.duration}
                </Typography>
              </Box>
            </MenuItem>
          ))}

          <Divider sx={{ my: 1 }} />

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button variant="contained" onClick={handleClose} sx={{ background: "linear-gradient(180deg, #805EDE 0%, #453378 100%)", width: "30px", height: "30px", borderRadius: "4px", WebkitTextFillColor: "white" }}>
              Apply
            </Button>
            <Button variant="contained" onClick={handleClose} sx={{ minWidth: "30px", height: "30px", borderRadius: "4px" }}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Menu>
    </Box>
  );
};

export default EventTypeDropdown;
